<template>
  <div class="p-users-admin">
    <page-title>Users</page-title>

    <tabs>
      <tabs-item :key="tabs.indexOf(tab)" v-for="tab in tabs" :link="tab.to">{{
        tab.title
      }}</tabs-item>
    </tabs>

    <section-block>
      <template slot="header">
        <filter-bar resource="users" show-search></filter-bar>
      </template>

      <template slot="actions">
        <base-button
          :primary="true"
          iconBefore="addUser"
          @click="onUserAddClick"
          type="button"
          >Add User</base-button
        >
      </template>
      <div v-if="!loading && users">
        <pagination table-pagination>
          <vuetable-pagination
            ref="pagination"
            @vuetable-pagination:change-page="onChangePage"
          ></vuetable-pagination>
        </pagination>
        <vuetable
          class="c-data-table"
          :api-mode="false"
          :fields="table.fields"
          :data-manager="dataManager"
          @vuetable:row-clicked="onRowClicked"
          :row-class="onRowClass"
          @vuetable:pagination-data="onPaginationData"
          pagination-path
          ref="vuetable"
        >
          <div slot="permissions" slot-scope="props">
            <ul class="c-permissions-list">
              <li
                v-for="(group, index) in getGroupString(
                  props.rowData.privilege_groups
                )"
                :key="index"
              >
                {{ group | titleCase }}
              </li>
            </ul>
          </div>
          <div slot="user-actions" slot-scope="props">
            <base-tooltip text="Edit">
              <icon name="pencil" />
            </base-tooltip>
            <button
              class="ui small button"
              @click="onActionClicked('edit-item', props.rowData)"
            >
              Delete
            </button>
            <button
              class="ui small button"
              @click="onActionClicked('delete-item', props.rowData)"
            >
              Block
            </button>
          </div>
        </vuetable>
        <pagination table-pagination>
          <vuetable-pagination
            ref="pagination"
            @vuetable-pagination:change-page="onChangePage"
          ></vuetable-pagination>
        </pagination>
      </div>
      <div v-else-if="!loading && users.length < 1">
        <p>No users found. Please try searching again</p>
      </div>
      <loading v-else></loading>
    </section-block>
  </div>
</template>

<script>
import FilterBar from '@/components/FilterBar.vue';
import UserActions from '@/components/UserActions';
import Pagination from '@/components/pagination';
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination';
import { mapState } from 'vuex';
export default {
  name: 'users-admin',

  data() {
    return {
      tabs: [
        {
          title: 'Users',
          to: '/admin/users',
        },
        {
          title: 'Blocked users',
          to: '/admin/users/blocked',
        },
      ],
      table: {
        fields: [
          {
            name: 'name',
            title: 'Name',
            width: '30%',
          },
          {
            name: 'email',
            title: 'Email',
          },
          {
            name: 'permissions',
            title: 'Privilege Groups',
            width: '20%',
            titleClass: 'u-hide-mobile',
            dataClass: 'u-hide-mobile',
          },
          {
            name: UserActions,
            title: 'Actions',
            titleClass: 'u-ta-center u-hide-mobile',
            dataClass: 'u-ta-center u-hide-mobile',
            width: '10%',
          },
        ],
      },
    };
  },

  beforeCreate() {
    this.$store.commit('users/RESET_FILTERS');
    if (this.$route.meta.filterBlocked) {
      this.$store.commit(
        'users/setBlockedFilter',
        this.$route.meta.filterBlocked
      );
    }
    this.$store.dispatch('users/list');
  },

  methods: {
    dataManager(sortOrder, pagination) {
      const returnObj = {
        ...this.$store.state.users.pagination,
        data: this.users,
      };

      return returnObj;
    },
    // TODO: Turn this into a computed string?  Something in the getter maybe?
    getGroupString(groups) {
      // console.log(groups);
      const result = Object.keys(groups).filter((key, val) => {
        if (groups[key]) {
          return key.split('_').join(' ');
        }
      });
      return result;
    },
    onRowClicked(dataItem) {
      if (dataItem.event.target.localName === 'td' || dataItem.event.target.parentNode.localName === 'td') {
        this.$store.commit('users/setCurrentUser', dataItem.data);
        this.$router.push({
          name: 'UserEdit',
          params: { userId: dataItem.data.id },
        });
      }
    },
    onUserAddClick() {
      this.$router.push({
        name: 'UserCreate',
      });
    },
    onRowClass(dataItem, index) {
      return dataItem.blocked ? 'tr-blocked' : 'tr-normal';
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      let nextPage;
      /**
       * Because why would the plugin send actual page numbers
       */
      switch (page) {
        case 'next':
          nextPage = ++this.$store.state.users.pagination.current_page;
          break;
        case 'prev':
          nextPage = --this.$store.state.users.pagination.current_page;
          break;
        default:
          nextPage = page;
          break;
      }

      const vm = this;
      const tableref = vm.$refs.vuetable;
      this.$store.dispatch('users/list', { page: nextPage }).then(resp => {
        window.scroll(0, 0);
        tableref.changePage(page);
      });
    },
  },

  computed: {
    ...mapState({
      users: state => state.users.collection,
    }),
    loading() {
      return this.$store.state.users.loading;
    },
  },

  components: {
    FilterBar,
    UserActions,
    VuetablePagination,
    Pagination,
  },
};
</script>

<style lang="scss">
.c-data-table {
  .tr-blocked {
    background: rgba($colour-nhs-emergency-red, 0.2);
    td {
      color: $colour-nhs-emergency-red;
    }
  }
}

.c-permissions-list {
  li {
    padding-bottom: 5px;
  }
}
</style>
